import React from 'react';

export const PhoneFormatter = ({ number }) => {
  if (!number) return "-";

  // Remove qualquer caractere que não seja número
  const cleaned = String(number).replace(/\D/g, "");

  // Celular (11 dígitos): (99) 99999-9999
  if (cleaned.length === 11) {
    return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
  }

  // Fixo (10 dígitos): (99) 9999-9999
  if (cleaned.length === 10) {
    return cleaned.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
  }

  return cleaned;
};